import FrontMixins from "../../common/mixins/front-mixins";
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
    mixins: [FrontMixins],
    created() {
        this.model = 'Meeting';
        this.$api("User.Incomplete",{},true).then(res=>{
            this.incomplete = parseInt( res.data.data );
        });
        if (this.$organization.org === 'sjtu') {
            if (this.$route.name === "会议列表") {
                //如果是交我办，或者mobile 就一定要去jwb的页面
                if (this.$isJWB() || this.$isMobile()) this.$router.replace("/jwb/meetings");
            } else {
                //如果不是交我办，则必须跳回来。
                if (!this.$isJWB() && !this.$isMobile()) this.$router.replace("/my-meeting");
            }
        }
    },
    data(){
        return {incomplete:0, poll_view:false,polls:{},
            table: {headers: [], data: []},
            show_table:false
        }
    },
    methods: {
        downloadReport() {
            this.$api('Report.Statistic.MeetingList', {own:true}, true).then((res) => {
                const data = res.data.data;
                this.table.headers = data.headers;
                this.table.data = data.data;
                //this.show_table = true;
                this.$nextTick(function () {
                    this.exportExcel('未来会议清单');
                })
            });
        },
        exportExcel(name) {
            /* generate workbook object from table */
            let wb = XLSX.utils.table_to_book(this.$refs['excel_table'],{raw: true});
            /* get binary string as output */
            let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
            let now = new Date().Format('yyyy-MM-dd');
            try {
                FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), `${name}-${now}.xlsx`)
            } catch (e) {
                console.log(e, wbout)
            }
            return wbout
        },
        startMeeting() {
            this.$api(this.model + '.Host', {id: this.single.id, review: true}, true).then(res => {
                let host_url = res.data.data.host_url;
                //window.open(host_url, '_blank');
                window.location.href = host_url;
                this.view_mode = false;
            });
        },
        mailAttendees() {
            let vm=this;
            this.$api(this.model + '.Mail.Attendee', {id: this.single.id}, true).then(() => {
                vm.$messageBox.success("邮件已经发送给参会者!");
            });
        },
        handleEdit(id) {
            if (id == 0) {
                this.$router.push('/new');
            } else {
                this.$router.push('/edit/' + id);
            }
        },
        handleOpenPollDialog(id) {
            let vm = this;
            this.$api(this.model + '.Poll',{id:id},true).then((res)=>{
                vm.single = Object.assign({selected:Object.keys(res.data.data.single.polls)},res.data.data.single);
                vm.polls = res.data.data.polls;
                this.poll_view = true;
            });
        },
        handleUpdate(single){
            this.single = this.$set(this,'single',single);
            const vm=this;
            this.$api(this.model+'.UpdatePoll',single,true).then(()=>{
                vm.$notice.success('更新完成!');
                vm.poll_view = false;
            });
        },
    },
    mounted() {
        window.scrollTo(0,0);
    },

}
